import { UiStateScope } from '../../../../lib/commons/uiStates'

export const isCrossProjectScope = (
  scope: UiStateScope,
  projectUuid?: string
) =>
  scope === UiStateScope.CrossProject ||
  (scope === UiStateScope.Tenant && !projectUuid)

export const isProjectScope = (scope: UiStateScope, projectUuid?: string) =>
  scope === UiStateScope.Tenant && !!projectUuid
